/// <amd-module name="Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ActionsUnion } from "redux/Utils/ActionHelper";
import { AuthorActions } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorActions";
import { ITestCaseAwareState, ITestCaseItem } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorContracts";
import { AuthorFilterReducer } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorFilterReducer";
import { AuthorReducer } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorReducer";
import { AuthorSaga } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorSaga";
import { SuitesReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesReducer";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";
import { testHubRefreshLocalContextData } from "Test/TestPlansHubRefresh/TestHub/Utils/TestPlansHubRefreshLocalContextProvider";

export function getAuthorModule(
    testCases: ITestCaseItem[],
    planId: number,
    initialSelectedSuiteId: number,
    selectedSuiteId: number
): ISagaModule<ITestCaseAwareState> {
    const initialActions: ActionsUnion<typeof AuthorActions>[] = [];

    initialActions.push(AuthorActions.initializeAuthorPivot());

    if (!testCases || testCases.length == 0) {
        // since loadInitialTestCases loads the data from json island, fire it only if the json island data is not dirty/stale
        if (initialSelectedSuiteId === selectedSuiteId && !testHubRefreshLocalContextData.isJsonIslandDataDirty()) {
            initialActions.push(AuthorActions.loadInitialTestCases());
        } else {
            initialActions.push(AuthorActions.loadTestCasesForSelectedSuite(planId, selectedSuiteId));
        }
    }

    return {
        id: "author",
        reducerMap: {
            authorState: AuthorReducer,
            testHubRefreshState: TestHubRefreshReducer,
            authorFilterState: AuthorFilterReducer,
            suiteState: SuitesReducer,
        },
        sagas: [AuthorSaga],
        initialActions: initialActions
    };
}
